export default {"src":"/_next/static/media/v13.f22ff410.svg","height":130,"width":332};